export default __webpack_public_path__ + "static/vnutorna-stanica-896d38fe5db8706d2c94594bcbb3fef4.png";